import React from 'react';
import './MatrixLogo.scss';

const MatrixLogo = () => (
  <div
    className="matrix-logo-container"
    title="01101101 01101001 01110100 01100011 01101000 00100000 01101001 01110011 00100000 01110011 01101011 01110101 01111000 01111000"
  >
    <img src="/assets/garage-project-signature-logo.png" alt="Garage Project logo" className="matrix-brand-logo" />
    <img src="/assets/garage-project-signature-logo.png" alt="" aria-hidden="true" className="matrix-brand-logo" />
    <img src="/assets/garage-project-signature-logo.png" alt="" aria-hidden="true" className="matrix-brand-logo" />
    <img src="/assets/matrix-rain.gif" alt="Matrix Rain" className="matrix-rain" />
  </div>
);

export default MatrixLogo;
